import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { post } from "../helper/api_helper";
import { toast } from "react-toastify";
import { setUser } from "../store/userSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CareveliProductHero from "../components/auth/CareveliProductHero";
import logoMark from "../assets/images/logo-2.png";

/** Normalize admin login payload (nested `user` or flat name/email/role). */
function normalizeAdminLogin(res) {
  if (!res?.success || !res?.token) return null;

  const raw = res.user && typeof res.user === "object" ? res.user : null;
  const user = {
    ...(raw || {}),
    _id: raw?._id || raw?.id || res._id || res.id,
    id: raw?.id || raw?._id || res.id || res._id,
    name: raw?.name || res.name || "Admin",
    email: raw?.email || res.email,
    role: raw?.role || res.role || "Admin",
    isAdmin: raw?.isAdmin ?? true,
  };

  if (!user.email && !user._id && !user.id) return null;
  return { token: res.token, user, message: res.message };
}

export default function Signin2() {
  const dispetch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const leaveTimer = useRef(null);

  useEffect(() => () => window.clearTimeout(leaveTimer.current), []);

  const handleValidSubmit = (e, v) => {
    setLoading(true);
    post("user/admin", v)
      .then(res => {
        setLoading(false);
        const auth = normalizeAdminLogin(res);
        if (auth) {
          localStorage.setItem("adminToken", auth.token);
          localStorage.setItem("adminUser", JSON.stringify(auth.user));
          dispetch(setUser({ ...auth.user, token: auth.token }));
          toast.success(auth.message || "Login successful");
          setLeaving(true);
          leaveTimer.current = window.setTimeout(() => navigate("/admin/dashboard"), 220);
        } else if (res?.success) {
          toast.error("Login succeeded but user data was missing. Please try again.");
        } else {
          toast.error(res?.message || "Login failed");
        }
      })
      .catch(err => {
        setLoading(false);
        console.error("error while login", err);
        toast.error("Something went wrong!");
      })
  }

  return (
    <div className={`page-sign login-premium d-block py-0${leaving ? " is-leaving" : ""}`}>
      <Row className="g-0">
        <Col xs="12" md="7" className="product-col">
          <CareveliProductHero />
        </Col>
        <Col xs="12" md="5" className="col-wrapper">
          <div className="login-panel">
            <div className="login-panel__brand-row">
              <img className="login-panel__mark" src={logoMark} alt="" aria-hidden="true" />
              <div>
                <p className="login-panel__brand">Careveli</p>
                <p className="login-panel__decoded">Beauty decoded</p>
              </div>
              <span className="login-panel__chip">Admin</span>
            </div>
            <h1 className="login-panel__title">Welcome back</h1>
            <p className="login-panel__lead">Sign in to manage orders, products and customers.</p>
            <AvForm onValidSubmit={handleValidSubmit}>
              <div className="mb-3 login-field">
                <i className="ri-mail-line login-field__icon" aria-hidden="true" />
                <AvField
                  name="email"
                  label="Email"
                  placeholder="name@email.com"
                  type="email"
                  required
                  errorMessage="Please enter a valid email"
                  autoComplete="username"
                />
              </div>
              <div className="mb-4 login-field password-field-wrap">
                <i className="ri-lock-2-line login-field__icon" aria-hidden="true" />
                <AvField
                  name="password"
                  label="Password"
                  placeholder="Enter your password"
                  type={showPassword ? "text" : "password"}
                  required
                  errorMessage="Password is required"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="password-toggle-btn"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  onClick={() => setShowPassword(prev => !prev)}
                >
                  <i className={showPassword ? "ri-eye-off-line" : "ri-eye-line"} />
                </button>
              </div>
              <button
                className="btn btn-sign"
                type="submit"
                disabled={loading || leaving}
              >
                {loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Signing In...
                  </>
                ) : (
                  <>
                    Sign In
                    <i className="ri-arrow-right-line btn-sign__arrow" aria-hidden="true" />
                  </>
                )}
              </button>
            </AvForm>
            <p className="login-panel__secure">
              <i className="ri-shield-check-line" aria-hidden="true" />
              Secure admin access · Sessions are encrypted
            </p>
          </div>
          <p className="login-footer">© {new Date().getFullYear()} Careveli · Beauty decoded</p>
        </Col>
      </Row>
    </div>
  )
}
